var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcBellSlash16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.714 2.305a4.455 4.455 0 0 1 7.604 3.15c0 2.133.457 3.458.877 4.229.211.387.417.64.56.792a2 2 0 0 0 .194.18l.002.001a.636.636 0 0 1-.36 1.161H2.136a.636.636 0 0 1-.36-1.16l.002-.002.033-.026q.053-.043.162-.154a3.8 3.8 0 0 0 .56-.792c.42-.771.876-2.096.876-4.23 0-1.18.47-2.314 1.305-3.15",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.455 13.09c.176 0 .32.144.292.318a1.91 1.91 0 0 1-3.766 0c-.03-.174.116-.317.292-.317z"
})));
export default SvgIcBellSlash16;